import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { supabaseUrl, supabaseKey } from '../config.ts';

const supabase = createClient(supabaseUrl, supabaseKey);

const Travel = () => {
    const [form, setForm] = useState({
        full_name: '',
        email: '',
        phone: '',
        from_location: '',
        to_location: '',
        travel_date: '',
        booking_type: 'one-way',
        for_women: false,
        adults: 1, // New state for adults, default to 1
        children: 0, // New state for children, default to 0
    });
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : (type === 'number' ? parseInt(value, 10) : value), // Parse number inputs
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setSuccess(false);

        let supabaseError = null;
        try {
            const { error } = await supabase.from('bookings').insert([
                {
                    full_name: form.full_name,
                    email: form.email,
                    phone: form.phone,
                    from_location: form.from_location,
                    to_location: form.to_location,
                    travel_date: form.travel_date,
                    booking_type: form.booking_type,
                    for_women: form.for_women,
                    adults: form.adults,
                    children: form.children,
                    status: 'pending',
                }
            ]);
            supabaseError = error;
        } catch (err) {
            supabaseError = err;
        }

        if (!supabaseError) {
            // Trigger N8N webhook after successful Supabase submission
            try {
                const response = await fetch('https://n8n.nicknameinfo.net/webhook/74384e68-e206-4458-8f90-d1e2eef57bea', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        fullName: form.full_name,
                        mobileNumber: form.phone,
                        emailAddress: form.email,
                        from: form.from_location,
                        to: form.to_location,
                        dateOfJourney: form.travel_date,
                        oneWay: (form.booking_type === 'one-way').toString(), // Convert boolean to string "true" or "false"
                        adults: form.adults,
                        children: form.children,
                        bookingForWomen: form.for_women.toString(), // Convert boolean to string "true" or "false"
                    }),
                });

                if (!response.ok) {
                    console.warn(`N8N webhook responded with status: ${response.status}. It might not have processed correctly.`);
                } else {
                    console.log('N8N webhook successfully triggered!');
                }
            } catch (apiError) {
                console.error('Error triggering N8N webhook:', apiError);
                // This error will not prevent the user from seeing the success message
                // as the primary booking submission to Supabase was successful.
            }

            setSuccess(true);
            setForm({
                full_name: '',
                email: '',
                phone: '',
                from_location: '',
                to_location: '',
                travel_date: '',
                booking_type: 'one-way',
                for_women: false,
                adults: 1,
                children: 0,
            });
        } else {
            console.error('Supabase submission error:', supabaseError);
            // You might want to add user-facing error handling here for Supabase failures
        }
        setSubmitting(false); // Always set to false at the end
    };

    return (
        <>
            <div
                className="container-fluid bg-breadcrumb"
                style={{
                    backgroundImage: "url('/assets/img/banner1.png')",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    padding: "250px 0",
                }}
            >
                <ul className="breadcrumb-animation">
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                </ul>
                <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                    {/* The image element previously added here is now redundant if it's the background */}
                    {/* <img
                        src="/assets/img/travels.png"
                        alt="Travels"
                        className="img-fluid mb-4 wow fadeInDown"
                        data-wow-delay="0.0s"
                        style={{ maxHeight: '200px' }} // Adjust size as needed
                    /> */}
                    <h3 className="display-3 my-4 wow fadeInDown" data-wow-delay="0.1s" style={{ color: "brown" }}>
                        {/* Book Your Journey */}
                    </h3>
                    <ol
                        className="breadcrumb justify-content-center mb-0 wow fadeInDown"
                        data-wow-delay="0.3s"
                    >
                        <li className="breadcrumb-item">
                            {/* <a href="/">Home</a> */}
                        </li>
                        {/* <li className="breadcrumb-item active text-primary">Book Your Journey</li> */}
                    </ol>
                </div>
            </div>
            <div className="container mb-5 pb-5 pt-2">
                {/* Success message div */}
                {success && (
                    <div
                        className="alert alert-success alert-dismissible fade show"
                        role="alert"
                    >
                        <strong>Success!</strong> Your journey details have been submitted successfully.
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                            onClick={() => setSuccess(false)}
                        />
                    </div>
                )}
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <form
                            id="journeyForm"
                            className="bg-white rounded-4 shadow-lg p-5 position-relative"
                            style={{
                                borderRadius: 30,
                                backdropFilter: "blur(10px)",
                                background: "rgba(255, 255, 255, 0.95)"
                            }}
                            onSubmit={handleSubmit}
                            autoComplete="off"
                        >
                            <h3 className="text-center mb-4 text-primary">Find Your Journey</h3>
                            {/* Personal Information */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            className="form-control border-0 border-bottom"
                                            id="nameInput"
                                            placeholder="Full Name"
                                            name="full_name"
                                            value={form.full_name}
                                            onChange={handleChange}
                                            required
                                            style={{ background: "none" }}
                                        />
                                        <label htmlFor="nameInput">
                                            <i className="fas fa-user me-2 text-primary" />
                                            Full Name
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="tel"
                                            className="form-control border-0 border-bottom"
                                            id="mobileInput"
                                            placeholder="Mobile Number"
                                            name="phone"
                                            pattern="[0-9]{10,15}"
                                            value={form.phone}
                                            onChange={handleChange}
                                            required
                                            style={{ background: "none" }}
                                        />
                                        <label htmlFor="mobileInput">
                                            <i className="fas fa-phone me-2 text-primary" />
                                            Mobile Number
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-floating mb-4">
                                <input
                                    type="email"
                                    className="form-control border-0 border-bottom"
                                    id="emailInput"
                                    placeholder="Email Address"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                    style={{ background: "none" }}
                                />
                                <label htmlFor="emailInput">
                                    <i className="fas fa-envelope me-2 text-primary" />
                                    Email Address
                                </label>
                            </div>
                            {/* From */}
                            <div className="form-floating mb-4">
                                <input
                                    type="text"
                                    className="form-control border-0 border-bottom"
                                    id="fromInput"
                                    placeholder="From"
                                    name="from_location"
                                    value={form.from_location}
                                    onChange={handleChange}
                                    required
                                    style={{ background: "none" }}
                                />
                                <label htmlFor="fromInput">
                                    <i className="fas fa-map-marker-alt me-2 text-primary" />
                                    From
                                </label>
                            </div>
                            {/* To */}
                            <div className="form-floating mb-4">
                                <input
                                    type="text"
                                    className="form-control border-0 border-bottom"
                                    id="toInput"
                                    placeholder="To"
                                    name="to_location"
                                    value={form.to_location}
                                    onChange={handleChange}
                                    required
                                    style={{ background: "none" }}
                                />
                                <label htmlFor="toInput">
                                    <i className="fas fa-map-marker-alt me-2 text-primary" />
                                    To
                                </label>
                            </div>
                            {/* Date of Journey and Booking Type */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input
                                            type="date"
                                            className="form-control border-0 border-bottom"
                                            id="dateInput"
                                            name="travel_date"
                                            value={form.travel_date}
                                            onChange={handleChange}
                                            required
                                            style={{ background: "none" }}
                                        />
                                        <label htmlFor="dateInput">
                                            <i className="far fa-calendar-alt me-2 text-primary" />
                                            Date of Journey
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex align-items-center gap-2 mt-3 mt-md-0">
                                    <select
                                        className="form-select rounded-pill"
                                        name="booking_type"
                                        value={form.booking_type}
                                        onChange={handleChange}
                                        style={{ minWidth: 120 }}
                                    >
                                        <option value="one-way">One Way</option>
                                        <option value="round-trip">Round Trip</option>
                                    </select>
                                </div>
                            </div>

                            {/* New: Adults and Children Fields */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="number"
                                            className="form-control border-0 border-bottom"
                                            id="adultsInput"
                                            placeholder="Adults"
                                            name="adults"
                                            value={form.adults}
                                            onChange={handleChange}
                                            min="1" // At least one adult required
                                            required
                                            style={{ background: "none" }}
                                        />
                                        <label htmlFor="adultsInput">
                                            <i className="fas fa-male me-2 text-primary" /> {/* Using male icon for adults */}
                                            Adults
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="number"
                                            className="form-control border-0 border-bottom"
                                            id="childrenInput"
                                            placeholder="Children"
                                            name="children"
                                            value={form.children}
                                            onChange={handleChange}
                                            min="0" // Children can be zero
                                            style={{ background: "none" }}
                                        />
                                        <label htmlFor="childrenInput">
                                            <i className="fas fa-child me-2 text-primary" /> {/* Using child icon for children */}
                                            Children
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Booking for women */}
                            <div
                                className="d-flex align-items-center p-3 rounded-4 mb-4"
                                style={{ background: "rgba(13, 110, 253, 0.05)" }}
                            >
                                <img
                                    src="../women.jpg"
                                    alt="woman"
                                    className="rounded-circle me-3"
                                    style={{
                                        width: 48,
                                        height: 48,
                                        boxShadow: "0 0 10px rgba(0,0,0,0.1)"
                                    }}
                                />
                                <div className="flex-grow-1">
                                    <h6 className="mb-0">Booking for women</h6>
                                    <a
                                        href="#"
                                        className="text-primary text-decoration-none"
                                        style={{ fontSize: 14 }}
                                    >
                                        Learn more about women's safety
                                    </a>
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="womenSwitch"
                                        name="for_women"
                                        checked={form.for_women}
                                        onChange={handleChange}
                                        style={{ width: "3em", height: "1.5em" }}
                                    />
                                </div>
                            </div>
                            {/* Search Button */}
                            <button
                                type="submit"
                                className="btn btn-primary btn-lg w-100 rounded-pill py-3 position-relative overflow-hidden"
                                disabled={submitting}
                            >
                                <span className="d-flex align-items-center justify-content-center">
                                    <i className="fas fa-search me-2" />
                                    {submitting ? "Submitting..." : "Search Now"}
                                </span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Travel